// Утилиты определения платформы/окружения для PWA.

/** iOS (iPhone/iPad/iPod), включая iPad на iPadOS, который представляется как Mac с тачем. */
export function isIOS(): boolean {
	const ua = navigator.userAgent
	const iOSDevice = /iPad|iPhone|iPod/.test(ua)
	const iPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
	return iOSDevice || iPadOS
}

/** Android-устройство. */
export function isAndroid(): boolean {
	return /Android/i.test(navigator.userAgent)
}

/** Десктопный macOS (не iPad на iPadOS, который тоже представляется как MacIntel). */
export function isMacOS(): boolean {
	return navigator.platform === 'MacIntel' && navigator.maxTouchPoints <= 1
}

/** Safari (а не Chrome/Firefox/Edge внутри iOS). На iOS standard-сценарий установки доступен только в Safari. */
export function isSafari(): boolean {
	const ua = navigator.userAgent
	return /Safari/i.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS|Chrome|Android/i.test(ua)
}

/** Приложение уже запущено в установленном виде (standalone), без адресной строки. */
export function isStandalone(): boolean {
	return (
		window.matchMedia('(display-mode: standalone)').matches ||
		// iOS Safari
		(window.navigator as unknown as { standalone?: boolean }).standalone === true
	)
}
